import {createSlice} from '@reduxjs/toolkit'

const initialState  = {
    name: '',
    forms: undefined,
}

const userSlice = createSlice({
    name:'user',
    initialState,
    reducers:{
        setName(state,action){
            state.name = action.payload;
        },
        setForms(state,action){
            var forms = [...action.payload];
            for(let i = 0;i < forms.length;i++){
                var min = i;
                for(let j = i + 1;j < forms.length;j++){
                    if(new Date(forms[j].examDate) >= new Date(forms[min].examDate)){
                        min = j;
                    }
                }

                var temp = forms[i];
                forms[i] = forms[min];
                forms[min] = temp;
            }
            state.forms = forms;
        },
    }
});

export const {setName,setForms} = userSlice.actions;
export default userSlice.reducer;